export function answers({ content }) {
  /*
    Return a version based on the number of answers and which one is correct.
  */
  return {
    optional: content.optional,
    answers: (content.answers || []).map((a) => !!a['@correct']),
  };
}
